import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Skills() {
  return (
    <section id="skills" className="skills-section">
      <Container>
        <h2 className="section-header">
          TECHNICAL<span className="purple"> SKILLS</span>
        </h2>

        <Row className="skills-content justify-content-center">
          <Col md={10} lg={10} xl={10}>
            <div className="skills-list mb-4">
              <p>
                <b className="purple">Programming Languages:</b> TypeScript,
                JavaScript, Java, Python, C, C++, HTML, CSS
              </p>
              <p>
                <b className="purple">Frontend:</b> Next.js, React, Redux,
                Tailwind CSS, NextAuth.js
              </p>
              <p>
                <b className="purple">Backend & APIs:</b> Node.js, Express.js,
                BullMQ, REST APIs, GraphQL, WebSockets, OAuth 2.0, JWT, Spring
                Boot, Spring Data JPA
              </p>
              <p>
                <b className="purple">Cloud & Infrastructure:</b> AWS CDK,
                CloudFormation, ASG, ALB, AppStream 2.0, SES, OpenSearch, EC2,
                ECR, S3, Lambda, Bedrock
              </p>
              <p>
                <b className="purple">Databases:</b> PostgreSQL, RDS, Supabase,
                Redis, ElastiCache, MongoDB, Neo4j, MySQL, Firebase
              </p>
              <p>
                <b className="purple">DevOps & Tools:</b> Docker, Kubernetes,
                Apache Kafka, Kafka Connect, Git
              </p>
              <p>
                <b className="purple">Testing:</b> Jest, React Testing Library,
                JUnit, Mockito
              </p>
            </div>

            <div className="skills-icon-grid">
              <img className="skill-icon" src="/Assets/Icons/typescript-icon.svg" alt="TypeScript" title="TypeScript" />
              <img className="skill-icon" src="/Assets/Icons/javascript.svg" alt="JavaScript" title="JavaScript" />
              <img className="skill-icon" src="/Assets/Icons/java.svg" alt="Java" title="Java" />
              <img className="skill-icon" src="/Assets/Icons/python.svg" alt="Python" title="Python" />
              <img className="skill-icon" src="/Assets/Icons/c.svg" alt="C" title="C" />
              <img className="skill-icon" src="/Assets/Icons/file-type-cpp2.svg" alt="C++" title="C++" />
              <img className="skill-icon" src="/Assets/Icons/HTML5_logo_resized.svg" alt="HTML5" title="HTML5" style={{ filter: "invert(1)" }} />
              <img className="skill-icon" src="/Assets/Icons/CSS3_logo_and_wordmark.svg" alt="CSS3" title="CSS3" style={{ filter: "invert(1)" }} />
              <img className="skill-icon" src="/Assets/Icons/nextjs.svg" alt="Next.js" title="Next.js" style={{ filter: "invert(1)" }} />
              <img className="skill-icon" src="/Assets/Icons/file-type-reactjs.svg" alt="React" title="React" />
              <img className="skill-icon" src="/Assets/Icons/redux-logo-svgrepo-com.svg" alt="Redux" title="Redux" />
              <img className="skill-icon" src="/Assets/Icons/Tailwind_CSS_Logo.svg" alt="Tailwind CSS" title="Tailwind CSS" />
              <img className="skill-icon" src="/Assets/Icons/nodejs-icon.svg" alt="Node.js" title="Node.js" />
              <img className="skill-icon" src="/Assets/Icons/express.svg" alt="Express.js" title="Express.js" style={{ filter: "invert(1)" }} />
              <img className="skill-icon" src="/Assets/Icons/springio-ar21.svg" alt="Spring Boot" title="Spring Boot" />
              <img className="skill-icon" src="/Assets/Icons/graphql.svg" alt="GraphQL" title="GraphQL" />
              <img className="skill-icon" src="/Assets/Icons/postgresql.svg" alt="PostgreSQL" title="PostgreSQL" />
              <img className="skill-icon" src="/Assets/Icons/redis.svg" alt="Redis" title="Redis" />
              <img className="skill-icon" src="/Assets/Icons/supabase.svg" alt="Supabase" title="Supabase" />
              <img className="skill-icon" src="/Assets/Icons/file-type-mongo.svg" alt="MongoDB" title="MongoDB" />
              <img className="skill-icon" src="/Assets/Icons/mysql.svg" alt="MySQL" title="MySQL" />
              <img className="skill-icon" src="/Assets/Icons/neo4j-icon.svg" alt="Neo4j" title="Neo4j" />
              <img className="skill-icon" src="/Assets/Icons/firebase.svg" alt="Firebase" title="Firebase" />
              <img className="skill-icon" src="/Assets/Icons/Amazon_Web_Services_Logo.svg" alt="AWS" title="AWS" style={{ filter: "invert(1)" }} />
              <img className="skill-icon" src="/Assets/Icons/docker-svgrepo-com.svg" alt="Docker" title="Docker" />
              <img className="skill-icon" src="/Assets/Icons/kubernetes-icon.svg" alt="Kubernetes" title="Kubernetes" />
              <img className="skill-icon" src="/Assets/Icons/kafka.svg" alt="Kafka" title="Kafka" style={{ filter: "invert(1)" }} />
              <img className="skill-icon" src="/Assets/Icons/git-icon.svg" alt="Git" title="Git" />
              <img className="skill-icon" src="/Assets/Icons/npm.svg" alt="NPM" title="NPM" />
              <img className="skill-icon" src="/Assets/Icons/jest.svg" alt="Jest" title="Jest" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Skills;
